<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6C1Fms/tc-custom/9781426841958.jpg?1705201661880" alt="This image is the cover for the book Keir O'Connell's Mistress, The O'Connells"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Keir O'Connell's Mistress, The O'Connells
      </h1>
      <p class="bookDescription body article font2">
        <b>A tycoon leaves Las Vegas for New England, but he can never run from his heart’s true desire, in this sexy contemporary romance.</b><br/><br/>Keir O’Connell knew it was time to leave Las Vegas when he fell for dancer Cassie Berk. Believing the desert heat must have addled his brain, he heads clear across the country, investing a small fortune in a vineyard in Connecticut. But he apparently wasn’t the only one looking for a change of scenery . . . <br/><br/>Setting up his new business is all going smoothly, until he discovers that Cassie has somehow gotten herself hired as his new restaurant manager. Keir’s rule had always been never to mix business with pleasure, but now he just had to take a gamble . . . he’d keep Cassie on as his manager <i>and</i> make her his mistress!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Marton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24263f10